import React, { useState, useContext } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import httpRequest from "../../httpRequest";
import ChangePasswordModal from "../ChangePasswordModal/ChangePasswordModal";
import ProfileModal from "../ProfileModal/ProfileModal";
import USER_PIC from "../../images/user.png";
import UserContext from "../../context/user-context"; // Import UserContext

const ProfileIcon = ({ avatar }) => {
  const [open, setOpen] = useState(null);
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const [showProfileOpen, setShowProfileOpen] = useState(false);
  const userCtx = useContext(UserContext); // Use UserContext instead

  const handleMenuOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleMenuClose = () => {
    setOpen(null);
  };

  const handlePasswordModalOpen = () => {
    setChangePasswordOpen(true);
    setOpen(null);
  };

  const handleClosePasswordModal = () => {
    setChangePasswordOpen(false);
  };

  const handleProfileModalOpen = () => {
    setShowProfileOpen(true);
    setOpen(null);
  };

  const handleCloseProfileModal = () => {
    setShowProfileOpen(false);
  };

  const logoutUser = async () => {
    await httpRequest.post(`${process.env.REACT_APP_BACKEND_URL}/logout`);
    // Clear any user data from UserContext
    userCtx.setUserData({
      name: null,
      email: null,
      employee_code: null,
      avatar: null,
      signature: null,
      user_id: null,
      role_id: null,
      role_overrides: false,
      overridden_role: {
        approver: false,
        forwarder: false,
        reviewer: false,
        canAccessAllCompanyScans: false,
        canAccessAllScans: false,
        canAccessExpense: false,
        canAccessScans: false,
        canAddDocuments: false,
        canAddExpense: false,
        canAddInvoice: false,
        canDeleteDocuments: false,
        canDeleteInvoice: false,
        canGeneralScan: false,
        canManageDocuments: false,
        canSettings: false,
        canUserManagement: false,
        companies: [],
        functions: [],
      },
    });
      // Clear cached avatar and signature from localStorage
      localStorage.removeItem("userAvatar");
      localStorage.removeItem("userSignature");
    window.location.href = "/login"; // Redirect to login after logout
  };

  return (
    <>
      <img
        src={avatar || USER_PIC}  // Use the avatar prop or fallback to default image
        alt="Profile"
        style={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          cursor: "pointer",
          objectFit: 'cover',
          objectPosition: 'center',
        }}
        onClick={handleMenuOpen}
      />
      <Menu anchorEl={open} open={Boolean(open)} onClose={handleMenuClose}>
        <MenuItem onClick={handleProfileModalOpen}>Profile</MenuItem>
        <MenuItem onClick={handlePasswordModalOpen}>Change password</MenuItem>
        <MenuItem onClick={logoutUser}>Log out</MenuItem>
      </Menu>
      <ChangePasswordModal open={changePasswordOpen} onClose={handleClosePasswordModal} />
      <ProfileModal open={showProfileOpen} onClose={handleCloseProfileModal} />
    </>
  );
};

export default ProfileIcon;
